import { GenerationDetails } from "../../store/slices/api/generationModels";

export const userAccounts: Record<number, GenerationDetails> = {
  // Basic user
  1: {
    accountId: "52324777-aa2f-4db0-8617-82ae9c5a813e",
    programId: "853775A8-EB1C-463C-8EB0-8A7BD0BF10E9",
    userId: "Data_Generation_Unverified",
    givenName: "bradley",
    surname: "bricks",
    email: "bradleybricks@gmail.com",
  },
  // Pending user (Looks the same as verified apparently)
  2: {
    accountId: "52324777-aa2f-4db0-8617-82ae9c5a813f",
    programId: "853775A8-EB1C-463C-8EB0-8A7BD0BF10E9",
    userId: "Data_Generation_Verified",
    givenName: "bruce",
    surname: "nails",
    email: "brucenails@gmail.com",
  },
  // Verified
  3: {
    accountId: "52324777-aa2f-4db0-8617-82ae9c5a813f",
    programId: "853775A8-EB1C-463C-8EB0-8A7BD0BF10E9",
    userId: "Data_Generation_Verified",
    givenName: "bruce",
    surname: "nails",
    email: "brucenails@gmail.com",
  },
  // Proxy
  4: {
    accountId: "52324777-aa2f-4db0-8617-82ae9c5a813d",
    programId: "853775A8-EB1C-463C-8EB0-8A7BD0BF10E9",
    userId: "Data_Generation_Proxy",
    givenName: "Randall",
    surname: "Jitters",
    email: "randalljitters@gmail.com",
  },
};
